const externalYtConnect = {
  'External YouTube Connect Title': 'YouTube ショッピング連携',
  'External YouTube Connect Description':
    'Google アカウントで認証することで、「<ShopLink></ShopLink>」と YouTube ショッピングチャンネルを連携できます。チャンネル上で商品を手軽に紹介できるようになります。',
  'External YouTube Connect Google Login Title':
    '1. Google アカウントにログイン',
  'External YouTube Connect Google Login Description':
    '連携する YouTube チャンネルのオーナー権限を持つ Google アカウントでログインしてください。',
  'External YouTube Connect Login': 'ログイン',
  'External YouTube Connect Logout': 'ログアウト',
  'External YouTube Connect Logout Popup Title': 'ログアウトしますか？',
  'External YouTube Connect Logout Popup Content':
    'ログアウトしてもよろしいですか？',
  'External YouTube Connect Logout Success': 'ログアウトしました',
  'External YouTube Connect Connected Channels Title':
    'チャンネルとストアを連携',
  'External YouTube Connect Connected Channels Description':
    '「連携する」をクリックすると、チャンネルとストアを連携できます。連携後は、チャンネルの管理画面でこのストアの商品を確認できます。',
  'External YouTube Connect Connected Channels Description Faq Tooltip':
    '一つの YouTube チャンネルには複数のストアを連携できます。今回の連携操作によって、既存の連携には影響しません。',
  'External YouTube Connect No Connected Channels Connect Button': '連携する',
  'External YouTube Connect Disconnect Channel': '連携を解除',
  'External YouTube Connect Connected Channels GMC Account Changed':
    'Google Merchant Center アカウント変更により、チャンネルの再連携が必要です',
  'External YouTube Connect No Eligible Channels':
    '現在ログインしている Google アカウントは、YouTube ショッピングの利用資格を満たすチャンネルのオーナーではありません。',
  'External YouTube Connect Disconnect Channel Popup Title':
    'このチャンネルと「{{shopName}}」との YouTube ショッピング連携を解除してもよろしいですか？',
  'External YouTube Connect Disconnect Channel Popup Content':
    '連携を解除すると、YouTube チャンネル上でストアの商品を表示できなくなります',
  'External YouTube Connect Disconnect Channel Popup Confirm': '解除する',
  'External YouTube Connect Disconnect Channel Popup Cancel': 'キャンセル',
  'External YouTube Connect Disconnect Channel Connect Success Toast':
    '連携しました',
  'External YouTube Connect Disconnect Channel Disconnect Success Toast':
    '解除しました',
  'External YouTube Connect Disconnect Channel Error Information Missing':
    '一部の情報が不足しています',
  'External YouTube Connect Disconnect Channel Error No Permission':
    '管理者権限が不足しています',
  'External YouTube Connect Disconnect Channel Error Not Eligible':
    'チャンネルは利用対象外です',
  'External YouTube Connect Disconnect Channel Error Something Wrong':
    'チャンネルでエラーが発生しました',
  'External YouTube Connect Disconnect Channel Error Already Linked':
    'チャンネルはすでに連携されています',
  'External YouTube Connect Connect Channel Error Merchant Not Integrated':
    'ストアに連携されている Google Merchant Center アカウントが無効です',
  'External YouTube Connect Add Channel': 'チャンネルを追加',
  'External YouTube Connect Channel Name': 'チャンネル名',
  'External YouTube Connect Channel ID': 'チャンネル ID',
  'External YouTube Connect Add Channel Success': 'チャンネルを追加しました',
  'External YouTube Connect Information Missing': '一部の情報が不足しています',
  'External YouTube Connect Add No Permission': '管理者権限が不足しています',
  'External YouTube Connect Channel Not Eligible': 'チャンネルは利用対象外です',
  'External YouTube Connect Add Channel Error':
    'チャンネルでエラーが発生しました',
  'External YouTube Connect Footer':
    "© 2013 - 2024 SHOPLINE. Asia's E-Commerce Solution.",
};

export default externalYtConnect;
